import type {RevertError as RevertErrorPayload} from '@github-ui/code-view-types'
import {Banner} from '@primer/react'

interface RevertErrorBannerProps {
  revertError?: RevertErrorPayload
}

export function RevertErrorBanner({revertError}: RevertErrorBannerProps) {
  if (!revertError) return null

  return (
    <Banner variant="critical" title={`Revert failed: ${revertError.heading}`} flush>
      {revertError.details ? (
        <Banner.Description>
          <pre>{revertError.details}</pre>
        </Banner.Description>
      ) : null}
    </Banner>
  )
}
